/**
 * The free internship's "not granted" line, carried to the page a new organization's owner lands on (Justin,
 * 2026-10-30; flagged for Miles).
 *
 * The organization mint answers `internship: { granted: false, reason }` (functions/src/rbac/functions/orgCreation.ts)
 * while the person is still on /onboarding, and the launch leaves with a hard navigation. This tab's sessionStorage
 * keeps the organization's id across it, so the page they land on can say the one line
 * (src/config/internshipWords.ts INTERNSHIP_WORDS.notGranted; src/components/wallet/TrialStatusBanner.tsx draws it).
 * The reason is the server's and is never kept or shown.
 *
 * A per-viewer convenience: storage that cannot be read only means the line is not shown, never that anything breaks.
 */

const KEY = 'prest0n:internship-not-granted';

/** How long the line waits for its page: a launch lands within moments; a day is ample and then it is forgotten. */
const KEEP_MS = 24 * 60 * 60 * 1000;

/** The mint said this organization's owner gets no free internship. */
export function rememberInternshipNotGranted(accountId: string, nowMs: number = Date.now()): void {
  if (!accountId) return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ accountId, atMs: nowMs }));
  } catch {
    /* no storage: the line is simply not carried */
  }
}

/** Whether the line belongs on this workspace's pages now. */
export function internshipNotGrantedFor(accountId: string | null | undefined, nowMs: number = Date.now()): boolean {
  if (!accountId) return false;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return false;
    const held = JSON.parse(raw) as { accountId?: unknown; atMs?: unknown } | null;
    if (!held || held.accountId !== accountId || typeof held.atMs !== 'number') return false;
    return nowMs - held.atMs >= 0 && nowMs - held.atMs < KEEP_MS;
  } catch {
    return false;
  }
}

/** The person closed the line (or it has served): it is not shown again. */
export function forgetInternshipNotGranted(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* nothing held */
  }
}
